import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiDownload } from 'react-icons/fi';
import {
  MdStorefront, MdCardGiftcard, MdTrendingUp, MdAccountBalanceWallet,
  MdPeople, MdBarChart, MdCheckCircle
} from 'react-icons/md';
import pointfinityLogo from '../assets/pointfinity-logo-mark.png';
import './Hero.css';

const stats = [
  { value: '500+', label: 'Stores' },
  { value: '50K+', label: 'Customers' },
  { value: '2M+', label: 'Points Issued' },
];

const dashboardRows = [
  { icon: <MdStorefront />, label: 'Active Stores', value: '124', color: '#1f78b9' },
  { icon: <MdPeople />, label: 'Total Customers', value: '8,452', color: '#00c853' },
  { icon: <MdCardGiftcard />, label: 'Points Issued', value: '182,400', color: '#67b7f7' },
  { icon: <MdAccountBalanceWallet />, label: 'Redemptions', value: '$4,320', color: '#f59e0b' },
  { icon: <MdTrendingUp />, label: 'Revenue Growth', value: '+34%', color: '#00c853' },
  { icon: <MdBarChart />, label: 'Active Offers', value: '38', color: '#a855f7' },
];

export default function Hero() {
  return (
    <section className="hero hero-gradient">
      <div className="container hero__inner">
        <div className="hero__content">
          <span className="hero__badge">
            <MdCheckCircle /> Trusted by 500+ Stores
          </span>
          <h1 className="hero__title">
            Multi-Store Loyalty<br />
            <span className="hero__title-highlight">&amp; Rewards Platform</span>
          </h1>
          <p className="hero__subtitle">
            Help stores reward customers, manage offers, redeem points, and grow repeat sales — all from one powerful dashboard.
          </p>
          <div className="hero__actions">
            <Link to="/contact" className="btn-primary">
              Get Started <FiArrowRight />
            </Link>
            <Link to="/download" className="btn-outline">
              <FiDownload /> Download App
            </Link>
          </div>
          <div className="hero__stats">
            {stats.map((s) => (
              <div key={s.label} className="hero__stat">
                <span className="hero__stat-value">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero__dashboard">
          <div className="dashboard-card">
            <div className="dashboard-header">
              <img src={pointfinityLogo} alt="Pointfinity logo" className="dashboard-logo-icon" />
              <span className="dashboard-title">Pointfinity Admin</span>
              <span className="dashboard-badge">Live</span>
            </div>
            <div className="dashboard-grid">
              {dashboardRows.map((row) => (
                <div key={row.label} className="dashboard-metric">
                  <div className="dashboard-metric__icon" style={{ background: row.color + '20', color: row.color }}>
                    {row.icon}
                  </div>
                  <div>
                    <div className="dashboard-metric__value">{row.value}</div>
                    <div className="dashboard-metric__label">{row.label}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="dashboard-chart">
              <div className="dashboard-chart__label">Monthly Points Issued</div>
              <div className="dashboard-bars">
                {[40, 65, 45, 80, 60, 90, 75, 85, 70, 95, 88, 100].map((h, i) => (
                  <div key={i} className="dashboard-bar" style={{ height: `${h}%` }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
